// src/Routes/Tools/config/mcqConfig.ts
import { ToolConfig } from "../../../Components/HighLevelComponents/Tool/types";
import MCQRenderer from "../../../Components/HighLevelComponents/Tool/renderers/MCQRenderer";

const mcqConfig: ToolConfig = {
  id: "mcq",
  title: "Multiple Choice Quiz Generator",
  description:
    "Create multiple choice questions with options from your text for effective assessment.",
  inputs: [
    {
      id: "text-input",
      name: "text",
      label: "Source Text",
      description:
        "Enter the text you want to generate multiple choice questions from",
      type: "textarea",
      required: true,
      placeholder: "Paste your text here...",
    },
    // Note: count and difficulty are handled by the Tool component directly
  ],
  promptId: 11, // ID of the MCQ generator prompt (adjust if your ID is different)
  resultRenderer: MCQRenderer,
};

export default mcqConfig;
